<template>
  <v-container id="page-group-detail">
    <div class="page-title">{{$route.name}}</div>

    <v-row justify="end">
      <c-btn class="mr-5 mb-3" outlined color="blue" @click="$router.go(-1)" >돌아가기</c-btn>
    </v-row>

    <group-info
      :groupDetailList="groupDetailList"
      :groupInfo="groupInfo"
    />
  </v-container>
</template>

<script>
  import GroupInfo from '../Common/GroupInfo';

  export default {
    components: {GroupInfo},
    data: () => ({
      groupInfo: [],
      groupDetailList: [],
    }),
    mounted() {
      const {groupId} = this.$route.params;
      this.reqGroupDetailList(groupId);
    },
    methods: {
      async reqGroupDetailList(groupId) {
        try {
          const res = await this.$api.getGroupDetailList(groupId);
          this.groupDetailList = res.data;
          if (this.groupDetailList.length > 0) this.groupInfo.push(this.groupDetailList[0].groupInfo);
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGroupDetailList'});
        }
      },
    },
  }
</script>

<style scoped>

</style>